import { z } from '@harvestiq/zod';

export const recipientSchema = z.object({
  name: z.string(),
  email: z.string().email(),
});

export type Recipient = z.infer<typeof recipientSchema>;
